import { useQuery } from '@tanstack/react-query';

import type { QueryFunction } from '@frontend/api';
import { useRequest } from '@frontend/api';

import type {
  PreferredDistributorQueryResult,
  UseGetPreferredDistributorQueryKey,
} from './types';
import { getUseGetPreferredDistributorQueryKey } from './utils';

export const useGetPreferredDistributor: QueryFunction<
  PreferredDistributorQueryResult,
  [],
  UseGetPreferredDistributorQueryKey
> = () => {
  const request = useRequest({});
  const queryKey = getUseGetPreferredDistributorQueryKey();

  return useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      return request('/products/default_preferred_distributor/', {
        init: {
          method: 'GET',
          signal,
        },
      });
    },
  });
};
